import { send } from "@/services/Api";
import AuthState from "@/utils/Auth";
import copy from "@/assets/languagePack/english";
import store from "@/store";

export const getCurrentProfessional = async () => {
  const claims = await AuthState.claims();
  const method = "get";
  const path = document.config.currentProfessionalAPI + claims.professionalId;
  try {
    const results = await send({ path, method, authToken: true });
    return results.data;
  } catch (error) {
    const errorDetails = {
      header: copy.api.errors.getCurrentProfessional || "Error",
      message: error
    };
    store.commit("errorHandler/toastableError", errorDetails);
    return {};
  }
};
